import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interfaz para un ítem del dropdown
export interface IDocumentIdentificationTypeDropdown {
  id: number;
  name: string; // description
  code: string;
}

// interfaz para el estado
export interface IDocumentIdentificationTypeState {
  documentIdentificationTypeDropdown: IDocumentIdentificationTypeDropdown[];
}

// estado inicial
export const initialState: IDocumentIdentificationTypeState = {
  documentIdentificationTypeDropdown: []
};

export const documentIdentificationTypeSlice = createSlice({
  name: 'documentIdentificationType',
  initialState,
  reducers: {
    loadingDocumentIdentificationTypeDropdown: (
      state,
      action: PayloadAction<IDocumentIdentificationTypeDropdown[]>
    ) => {
      state.documentIdentificationTypeDropdown = action.payload;
    },
  },
});

export const { loadingDocumentIdentificationTypeDropdown } = documentIdentificationTypeSlice.actions;

export default documentIdentificationTypeSlice.reducer;
